/**
 * Modal B2B - Connexion et Inscription multi-étapes
 */

const authModalB2B = {
  currentStep: 1,
  formData: {},

  init() {
    console.log('🔐 Auth Modal B2B initialized');
    this.attachEventListeners();
    this.interceptLoginLinks();
  },

  /**
   * Intercepter tous les liens "/account/login" pour ouvrir la modal
   */
  interceptLoginLinks() {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('a[href="/account/login"]');
      if (target) {
        e.preventDefault();
        this.open();
      }
    });
  },

  /**
   * Attacher les event listeners
   */
  attachEventListeners() {
    const modal = document.getElementById('auth-modal-b2b');
    if (!modal) return;

    // Fermer la modal
    const closeBtn = modal.querySelector('.auth-modal__close');
    const overlay = modal.querySelector('.auth-modal__overlay');
    const container = modal.querySelector('.auth-modal__container');

    closeBtn?.addEventListener('click', () => this.close());
    overlay?.addEventListener('click', () => this.close());

    // Fermer si on clique à l'extérieur du container
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        this.close();
      }
    });

    // Empêcher la fermeture si on clique sur la modal elle-même
    container?.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Touche Escape pour fermer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        this.close();
      }
    });

    // Toggle password visibility
    const passwordToggles = modal.querySelectorAll('.auth-modal__password-toggle');
    passwordToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        const input = e.currentTarget.previousElementSibling;
        const eyeOpen = e.currentTarget.querySelector('.eye-open');
        const eyeClosed = e.currentTarget.querySelector('.eye-closed');

        if (input.type === 'password') {
          input.type = 'text';
          eyeOpen.style.display = 'none';
          eyeClosed.style.display = 'block';
        } else {
          input.type = 'password';
          eyeOpen.style.display = 'block';
          eyeClosed.style.display = 'none';
        }
      });
    });

    // Validation des étapes
    const step1Form = document.getElementById('modal-register-step1');
    const step2Form = document.getElementById('modal-register-step2');

    if (step1Form) {
      step1Form.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    }

    if (step2Form) {
      step2Form.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    }

    // Afficher le nom du fichier KBIS sélectionné
    const kbisInput = document.getElementById('company-kbis');
    const kbisFileName = document.getElementById('kbis-file-name');
    if (kbisInput && kbisFileName) {
      kbisInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
          kbisFileName.textContent = file.name;
        } else {
          kbisFileName.textContent = '';
        }
      });
    }
  },

  /**
   * Ouvrir la modal
   */
  open() {
    const modal = document.getElementById('auth-modal-b2b');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      // Ajouter le flou sur le contenu du site
      const mainContent = document.querySelector('body > *:not(#auth-modal-b2b)');
      const header = document.querySelector('.section-header');
      const footer = document.querySelector('.section-footer');
      const mainSections = document.querySelectorAll('.shopify-section:not(#auth-modal-b2b)');

      // Appliquer le flou
      if (mainContent) {
        document.body.classList.add('modal-open-blur');
      }

      console.log('✅ Modal opened');
    }
  },

  /**
   * Fermer la modal
   */
  close() {
    const modal = document.getElementById('auth-modal-b2b');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';

      // Retirer le flou
      document.body.classList.remove('modal-open-blur');

      this.resetForm();
      console.log('❌ Modal closed');
    }
  },

  /**
   * Passer à l'étape suivante
   */
  async nextStep() {
    if (this.currentStep === 1) {
      if (!this.validateStep1()) {
        return;
      }

      // Uploader le KBIS avant de passer à l'étape 2
      const kbisUrl = await this.uploadKBIS();
      if (!kbisUrl) {
        alert('Erreur lors de l\'upload du KBIS. Veuillez réessayer.');
        return;
      }

      this.formData.kbisUrl = kbisUrl;
      this.saveStep1Data();
      this.showStep(2);
    } else if (this.currentStep === 2) {
      if (!this.validateStep2()) {
        return;
      }
      this.saveStep2Data();
      this.showSummary();
      this.showStep(3);
    }
  },

  /**
   * Revenir à l'étape précédente
   */
  previousStep() {
    if (this.currentStep === 2) {
      this.showStep(1);
    } else if (this.currentStep === 3) {
      this.showStep(2);
    }
  },

  /**
   * Afficher une étape spécifique
   */
  showStep(stepNumber) {
    const steps = document.querySelectorAll('.auth-modal__step');
    steps.forEach(step => {
      step.style.display = 'none';
    });

    const targetStep = document.querySelector(`.auth-modal__step[data-step="${stepNumber}"]`);
    if (targetStep) {
      targetStep.style.display = 'block';
      this.currentStep = stepNumber;
      console.log(`📍 Step ${stepNumber}`);
    }
  },

  /**
   * Valider l'étape 1
   */
  validateStep1() {
    const companyName = document.getElementById('company-name').value.trim();
    const siret = document.getElementById('company-siret').value.trim();
    const address = document.getElementById('company-address').value.trim();
    const city = document.getElementById('company-city').value.trim();
    const postalCode = document.getElementById('company-postal-code').value.trim();
    const kbisFile = document.getElementById('company-kbis').files[0];

    if (!companyName || !siret || !address || !city || !postalCode) {
      alert('Veuillez remplir tous les champs obligatoires');
      return false;
    }

    // Validation SIRET (14 chiffres)
    const siretClean = siret.replace(/\s/g, '');
    if (siretClean.length !== 14 || !/^\d+$/.test(siretClean)) {
      alert('Le numéro SIRET doit contenir exactement 14 chiffres');
      return false;
    }

    // Validation code postal (5 chiffres)
    if (postalCode.length !== 5 || !/^\d+$/.test(postalCode)) {
      alert('Le code postal doit contenir exactement 5 chiffres');
      return false;
    }

    // Validation fichier KBIS
    if (!kbisFile) {
      alert('Veuillez télécharger votre document KBIS');
      return false;
    }

    // Vérifier la taille (max 10 MB)
    if (kbisFile.size > 10 * 1024 * 1024) {
      alert('Le fichier KBIS est trop volumineux. Maximum 10 MB.');
      return false;
    }

    // Vérifier le type
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(kbisFile.type)) {
      alert('Format de fichier non autorisé. Formats acceptés : PDF, JPG, PNG');
      return false;
    }

    return true;
  },

  /**
   * Uploader le fichier KBIS vers Cloudflare R2
   */
  async uploadKBIS() {
    const kbisFile = document.getElementById('company-kbis').files[0];
    const progressBar = document.getElementById('kbis-upload-progress');

    if (!kbisFile) {
      return null;
    }

    try {
      // Afficher la barre de progression
      progressBar.style.display = 'block';

      // Créer le FormData
      const formData = new FormData();
      formData.append('kbis', kbisFile);

      console.log('📤 Upload KBIS en cours...', kbisFile.name);

      // Upload vers Cloudflare Worker
      const response = await fetch('https://kbis-upload-worker.damp-bonus-0625.workers.dev', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        console.error('❌ Erreur upload:', error);
        throw new Error(error.error || 'Erreur upload');
      }

      const result = await response.json();
      console.log('✅ KBIS uploadé:', result.url);

      // Cacher la barre de progression
      progressBar.style.display = 'none';

      return result.url;

    } catch (error) {
      console.error('❌ Erreur upload KBIS:', error);
      progressBar.style.display = 'none';
      return null;
    }
  },

  /**
   * Sauvegarder les données de l'étape 1
   */
  saveStep1Data() {
    this.formData.companyName = document.getElementById('company-name').value.trim();
    this.formData.siret = document.getElementById('company-siret').value.trim();
    this.formData.address = document.getElementById('company-address').value.trim();
    this.formData.city = document.getElementById('company-city').value.trim();
    this.formData.postalCode = document.getElementById('company-postal-code').value.trim();
    console.log('💾 Step 1 data saved:', this.formData);
  },

  /**
   * Valider l'étape 2
   */
  validateStep2() {
    const firstname = document.getElementById('contact-firstname').value.trim();
    const lastname = document.getElementById('contact-lastname').value.trim();
    const email = document.getElementById('contact-email').value.trim();
    const phone = document.getElementById('contact-phone').value.trim();
    const password = document.getElementById('contact-password').value;

    if (!firstname || !lastname || !email || !phone || !password) {
      alert('Veuillez remplir tous les champs obligatoires');
      return false;
    }

    // Validation email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Veuillez entrer une adresse email valide');
      return false;
    }

    // Validation mot de passe
    if (password.length < 8) {
      alert('Le mot de passe doit contenir au moins 8 caractères');
      return false;
    }

    return true;
  },

  /**
   * Sauvegarder les données de l'étape 2
   */
  saveStep2Data() {
    this.formData.firstname = document.getElementById('contact-firstname').value.trim();
    this.formData.lastname = document.getElementById('contact-lastname').value.trim();
    this.formData.email = document.getElementById('contact-email').value.trim();
    this.formData.phone = document.getElementById('contact-phone').value.trim();
    this.formData.password = document.getElementById('contact-password').value;
    console.log('💾 Step 2 data saved:', this.formData);
  },

  /**
   * Afficher le récapitulatif
   */
  showSummary() {
    // Remplir le récapitulatif
    document.getElementById('summary-company-name').textContent = this.formData.companyName;
    document.getElementById('summary-siret').textContent = this.formData.siret;
    document.getElementById('summary-address').textContent = this.formData.address;
    document.getElementById('summary-city').textContent = this.formData.city;
    document.getElementById('summary-postal-code').textContent = this.formData.postalCode;
    document.getElementById('summary-fullname').textContent = `${this.formData.firstname} ${this.formData.lastname}`;
    document.getElementById('summary-email').textContent = this.formData.email;
    document.getElementById('summary-phone').textContent = this.formData.phone;

    // Remplir les champs cachés du formulaire final
    document.getElementById('final-firstname').value = this.formData.firstname;
    document.getElementById('final-lastname').value = this.formData.lastname;
    document.getElementById('final-email').value = this.formData.email;
    document.getElementById('final-password').value = this.formData.password;

    // Remplir les champs d'adresse par défaut
    document.getElementById('final-address-firstname').value = this.formData.firstname;
    document.getElementById('final-address-lastname').value = this.formData.lastname;
    document.getElementById('final-company').value = this.formData.companyName;
    document.getElementById('final-address').value = this.formData.address;
    document.getElementById('final-city').value = this.formData.city;
    document.getElementById('final-postal-code').value = this.formData.postalCode;
    document.getElementById('final-phone').value = this.formData.phone;

    // Créer la note avec toutes les infos B2B + marqueur d'attente de validation + KBIS
    const note = `[PENDING-APPROVAL] Entreprise: ${this.formData.companyName} | SIRET: ${this.formData.siret} | Adresse: ${this.formData.address} | Ville: ${this.formData.city} | Code postal: ${this.formData.postalCode} | Téléphone: ${this.formData.phone} | KBIS: ${this.formData.kbisUrl || 'Non fourni'}`;
    document.getElementById('final-note').value = note;

    console.log('📋 Summary displayed');
    console.log('📊 DONNÉES DU FORMULAIRE:', this.formData);
    console.log('🔍 CHAMPS CACHÉS REMPLIS:');
    console.log('  - Prénom:', document.getElementById('final-firstname').value);
    console.log('  - Nom:', document.getElementById('final-lastname').value);
    console.log('  - Email:', document.getElementById('final-email').value);
    console.log('  - Mot de passe:', document.getElementById('final-password').value ? '***' : 'VIDE');
    console.log('  - Entreprise (adresse):', document.getElementById('final-company').value);
    console.log('  - Adresse:', document.getElementById('final-address').value);
    console.log('  - Ville:', document.getElementById('final-city').value);
    console.log('  - Code postal:', document.getElementById('final-postal-code').value);
    console.log('  - Téléphone:', document.getElementById('final-phone').value);
    console.log('  - Note:', document.getElementById('final-note').value);

    // Logger le formulaire au moment du submit
    const finalForm = document.getElementById('modal-register-final-form');
    if (finalForm && !finalForm.dataset.listenerAdded) {
      finalForm.dataset.listenerAdded = 'true';
      finalForm.addEventListener('submit', (e) => {
        console.log('🚀 ENVOI DU FORMULAIRE !');
        console.log('📦 DONNÉES ENVOYÉES À SHOPIFY:');
        const formData = new FormData(finalForm);
        for (let [key, value] of formData.entries()) {
          if (key.includes('password')) {
            console.log(`  ${key}: ***`);
          } else {
            console.log(`  ${key}: ${value}`);
          }
        }
      });
    }
  },

  /**
   * Réinitialiser le formulaire
   */
  resetForm() {
    this.currentStep = 1;
    this.formData = {};
    this.showStep(1);

    // Reset tous les champs
    const forms = document.querySelectorAll('.auth-modal__form');
    forms.forEach(form => {
      if (form.tagName === 'FORM') {
        form.reset();
      }
    });

    console.log('🔄 Form reset');
  }
};

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  authModalB2B.init();
});
